// Initialize only the multiple selects that don't have specific configurations
$("select[multiple]").select2({
  width: "300px",
  placeholder: "Select options",
  minimumResultsForSearch: 0,
});

function updateSelectionCount(element) {
  let select = element,
    ul = select.next("span.select2").find("ul");

  // Always remove previous custom count choice display
  ul.find(".select2-selection__choice").remove();

  let count = select.select2("data").length;

  // Only add the count display if one or more items are selected
  if (count > 0) {
    ul.prepend(function () {
      let text = count === 1 ? " item selected" : " items selected";
      return "<li class='select2-selection__choice'>" + count + text + "</li>";
    });
  }
}

$("select[multiple]").on("select2:close", function () {
  updateSelectionCount($(this));
});

// Update count on page load
$(function () {
  $("select[multiple]").each(function () {
    updateSelectionCount($(this));
  });
});
